<template>
  <div class="template-card">
    <snt-printer
      :items="canvas"
      :callback="callbackPrinter"
      :aspect-ratio="aspectRatio"
      :width="width"
      :height="height"
      :inner-width="innerWidth"
      :inner-height="innerHeight"
      :margin="margin">
      <template #header>
        <div class="template-card__header d-flex ma-1">
          <div class="mr-1">
            <RemovePaper
              :item-id="itemId"
              @submitted="$emit('removed')" />
          </div>
          <div class="mr-1">
            <CopyPaper
              :item-id="itemId"
              class="ml-1" />
          </div>
          <v-btn
            :to="`/document/edit/${itemId}`"
            color="primary"
            small
            depressed>
            {{ $t('app.btn.edit') }}
          </v-btn>
        </div>
      </template>
      <template #footer>
        <div />
      </template>
    </snt-printer>
  </div>
</template>

<script>
import { GET_PAPERGETSIZE } from '@/resources/graphql'
import PapersMixin from '@/views/Papers/mixins/papers'
import RemovePaper from './RemovePaper.vue'
import CopyPaper from './CopyPaper.vue'

export default {
  components: {
    RemovePaper,
    CopyPaper
  },
  mixins: [PapersMixin],
  apollo: {
    paperGetSize: {
      query: GET_PAPERGETSIZE
    }
  },
  props: {
    itemId: {
      type: [String, Number],
      required: true
    },
    paperSize: {
      type: [String],
      default: ''
    },
    innerHeight: {
      type: [String, Number],
      default: 185
    },
    innerWidth: {
      type: [String, Number],
      default: 260
    },
    margin: {
      type: [Number],
      default: 0
    },
    canvas: {
      type: [Array],
      default: () => ([])
    },
    aspectRatio: {
      type: [Number],
      default: 0.3
    }
  },
  data () {
    return {
      paperGetSize: []
    }
  },
  computed: {
    size () {
      return this.paperGetSize.find(({ key }) => key === this.paperSize)
    },
    height () {
      return this.size?.height || 1123
    },
    width () {
      return this.size?.width || 794
    }
  }
}
</script>
<style lang="scss" scoped>
  .template-card {
    width: 247px;
    height: 345px;
    background: #ffffff;
    box-shadow:
      0px 22.59px 63.2px rgba(109, 126, 189, 0.08),
      0px 6.02px 24.09px rgba(109, 126, 189, 0.07),
      0px 2.26px 10.54px rgba(109, 126, 189, 0.25),
      0px 0.75px 2.26px rgba(109, 126, 189, 0.13);
    &__header {
      position: absolute;
      padding: 4px;
      z-index: 1;
    }
    ::v-deep {
      .printer-preview {
        &__container {
          padding: 4px !important;
          min-height: 260px;
          height: 345px;
          width: 247px;
          overflow: hidden !important;
          background: #ffffff;
          align-items: center;
        }
        #printable {
          overflow: hidden;
          box-shadow:
            1px 0px 8px 0px #f5f5f5,
            0px 6.02px 20.09px #f5f5f5,
            0px 2.26px 10.54px rgba(19, 10, 46, 0.25),
            0px 0.75px 2.26px rgba(19, 10, 46, 0.13);
        }
      }
    }
  }
</style>
